/**
 * Styled Components - Created by david on 30/07/18.
 */
import styled from 'styled-components'

export const Container = styled.div`
  padding: 8px;
  border: solid;
  border-width: 1px;
  border-color: #fafafa;
  margin-bottom: 16px;
`

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`

export const Text = styled.div`
  color: #fff;
`

export const Label = styled.div`
  color: #5f6062;
  font-size: 14px;
  letter-spacing: 0.18px;
  line-height: 19px;
`



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/ExtraFile/styledComponents.tsx